import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Banner extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const {
            content: { img, title, url },
        } = this.props;

        return (
            <div className={styles.banner_box}>
                <div className={styles.banner}>
                    <img src={img} alt="" />
                    <a href={url}>| {title}</a>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Banner);
